import { isFilled } from "@prismicio/client";
import { PrismicImage, PrismicLink, PrismicRichText } from "@prismicio/react";

/**
 * @typedef {import("@prismicio/client").Content.WideCardSlice} WideCardSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<WideCardSlice>} WideCardProps
 * @type {import("react").FC<WideCardProps>}
 */
const WideCard = ({ slice }) => {
  return (
    <section
      className="contre-uno bg-[image:var(--wide-bg)] bg-cover padding-y-lg px-6 bg-bottom-left"
      style={
        isFilled.image(slice.primary.bg_picture)
          ? { "--wide-bg": `url(${slice.primary.bg_picture.url})` }
          : undefined
      }
    >
      <div className="p-6 flex flex-col lg:flex-row gap-6 items-center max-w-[1250px] mx-auto bg-bleu-50 rounded-xl border-6 border-bleu-200">
        <div className="text-bleu-950 lg:w-2/3 py-12 lg:pl-12">
          {isFilled.richText(slice.primary.title) && (
            <PrismicRichText
              field={slice.primary.title}
              components={{
                heading2: ({ children }) => <h2 className="h4 mb-4">{children}</h2>,
                heading3: ({ children }) => <h3 className="h4 mb-4">{children}</h3>,
              }}
            />
          )}

          {isFilled.richText(slice.primary.text) && (
            <div className="flex flex-col gap-2">
              <PrismicRichText
                field={slice.primary.text}
                components={{
                  paragraph: ({ children }) => <p className="body-s">{children}</p>,
                  strong: ({ children }) => <strong>{children}</strong>,
                  em: ({ children }) => <em>{children}</em>,
                }}
              />
            </div>
          )}
        </div>
        <div className="md:w-1/3">
          {isFilled.image(slice.primary.picture) && (
            <PrismicImage className="rounded-lg"
              field={{
                ...slice.primary.picture,
                alt: slice.primary.picture.alt || "Image d'illustration",
              }}
            />
          )}
        </div>
      </div>
    </section>
  );
};

export default WideCard;
